import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { formatDateToLocale } from 'util/formatters/dateFormatter';
import { locale } from '@tcc/i18n';

const OverlayQuickDateSelect = ({
  hasNextDate,
  hasPreviousDate,
  onSelectNext,
  onSelectPrevious,
  selectedDate
}) => {
  if (!selectedDate || ( !hasNextDate && !hasPreviousDate) ) {
    return null;
  }
  const prevClass = classNames({
    'layer-quick-date-menu__button--left': true,
    'layer-quick-date-menu__button--left-disabled': !hasPreviousDate
  });
  const nextClass = classNames({
    'layer-quick-date-menu__button--right': true,
    'layer-quick-date-menu__button--right-disabled': !hasNextDate
  });
  return (
    <div className='layer-quick-date-menu__container'>
      <button className={prevClass}
        disabled={!hasPreviousDate}
        onClick={ onSelectPrevious }
      />
      <span className='layer-quick-date-menu__date-title'>{formatDateToLocale(selectedDate, locale)}</span>
      <button className={nextClass}
        disabled={!hasNextDate}
        onClick={ onSelectNext }
      />
    </div>
  );
};

OverlayQuickDateSelect.propTypes = {
  hasNextDate: PropTypes.bool.isRequired,
  hasPreviousDate: PropTypes.bool.isRequired,
  onSelectNext: PropTypes.func.isRequired,
  onSelectPrevious: PropTypes.func.isRequired,
  selectedDate: PropTypes.string
};

export default OverlayQuickDateSelect;
